import React from 'react';

import DropzoneUploadCloudIcon from '../../../assets/images/dropzone-upload-cloud.svg';

const zIndexVariants = {
  messages: 'z-(--stack-messages-dropzone-explainer)',
  sidebar: 'z-(--stack-sidebar-header)',
  agentChat: 'z-(--stack-agent-chat-dropzone-explainer)',
  widgetComposerHome: 'z-(--stack-widget-composer-home-dropzone-explainer)',
};

const DropOverlay = ({ isVisible, label, zIndexVariant = 'messages', onImage = false }) => {
  const visibilityClasses = isVisible ? 'pointer-events-auto opacity-100' : 'pointer-events-none opacity-0';

  const overlayClassName = `
    dropzone-message absolute inset-0 ${zIndexVariants[zIndexVariant]}
    flex items-center justify-center
    backdrop-blur-xl
    ${onImage ? 'bg-black/60 backdrop-saturate-200' : 'bg-white/80 dark:bg-neutral-950/80'}
    transition-opacity duration-200
    ${visibilityClasses}
  `;

  return (
    <div className={overlayClassName}>
      <div
        className={`flex flex-wrap items-center justify-center gap-2 px-4 text-center text-lg font-semibold ${
          onImage ? 'text-white' : 'text-gray-900 dark:text-white'
        }`}
      >
        <DropzoneUploadCloudIcon className="size-8 shrink-0" />
        <span>{label}</span>
      </div>
    </div>
  );
};

export default DropOverlay;
